exports = module.exports = require("../../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".video-fullscreen{cursor:pointer}.video-fullscreen:hover{background-color:#1a1a1a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-html5video/src/components/controls/fullscreen/fullscreen.css
// module id = 1372
// module chunks = 0